import { getDocumentPath } from '../actions/documentActions';

export const syncClientDocumentsMiddleware = (store) => (next) => (action) => {
  const prevState = store.getState();
  const result = next(action);
  const nextState = store.getState();

  // Check if client slice changed
  if (action.type === 'SELECT_CURRENT_CLIENT') {
    const prevClient = prevState.clientState?.currentClient?.clientId;
    const newClient = nextState.clientState?.currentClient?.clientId;

    if (prevClient !== newClient) {
      store.dispatch(getDocumentPath(null));
    }
  }

  return result;
};
